import React from "react";
import { Dropdown } from "react-bootstrap";
import { connect } from "react-redux";
import PageHeader from "../../../components/PageHeader";
import { Link } from "react-router-dom";
import StockMovementsTable from "../../../components/Tables/StockMovementsTable";
import {withRouter} from "react-router-dom";
import withPermissions from "../../../components/WithPermissions";
import ManagementPageHero from "../../../components/ManagementPageHero";

class StockMovements extends React.Component {
  componentDidMount() {
    window.scrollTo(0, 0);
  }

  render() {
    const {userPermissions} = this.props;
    const userHasCreatePermission = userPermissions.includes('stock.movement');

    return (
      <div
        className="management-page"
        onClick={() => {
          document.body.classList.remove("offcanvas-active");
        }}
      >
        <div>
          <div className="container-fluid">
            <PageHeader
                HeaderText="Stok Hareketleri"
                Breadcrumb={[
                  {name: "Stok Yönetimi", navigate: ""},
                  {name: "Stok Hareketleri", navigate: ""},
                ]}
            />
            <ManagementPageHero
              eyebrow="STOK HAREKETLERİ"
              title="Tüm stok giriş ve çıkışlarını izleyin"
              description="Ürün hareketlerini tür, depo ve tarih bilgileriyle birlikte takip edin."
              actionTo={userHasCreatePermission ? "/stock/movement-add" : null}
              actionLabel="Yeni hareket"
            />
            <div className="row clearfix">
              <div className="col-lg-12 col-md-12">
                <div className="card planned_task management-list-card">
                  <div className="header">
                    <h2>Stok Hareketleri</h2>
                    {userHasCreatePermission ? (
                        <Dropdown as="ul" className="header-dropdown">
                          <Dropdown.Toggle
                              variant="success"
                              as="li"
                              id="dropdown-basic"
                          >
                            <i className="icon-plus text-success p-1 ml-1"></i>
                            <Dropdown.Menu
                                as="ul"
                                className="dropdown-menu dropdown-menu-right"
                            >
                              <li>
                                <Link to="/stock/movement-add">Yeni Hareket</Link>
                              </li>
                            </Dropdown.Menu>
                          </Dropdown.Toggle>
                        </Dropdown>
                    ) : ""}
                  </div>
                  <div className="body">
                    <StockMovementsTable />
                  </div>
                </div>
              </div>
            </div>
            <style>
              {`
                #dropdown-basic::after {
                    display: none;
                }
              `}
            </style>
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = ({stockReducer}) => ({});

export default withPermissions(withRouter(connect(mapStateToProps, {})(StockMovements)));




